<template>
  <div class="tables-basic">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>

      <h2 class="page-title">Valid Spelling Admin</h2>


      <b-row v-if="spelling">
        <b-col>
          <Widget
                  title="Latest Users"
          >
            <table class="table table-hover table-sm" >
              <thead>
              <tr>
                <th scope="col">Word</th>
                <th scope="col">Delete</th>
              </tr>
              </thead>
              <tbody>
            <tr v-for="(word) in spelling.valid_words">
              <td>
                {{word}}
              </td>
              <td><a @click.prevent="deleteWord(word)" href="#here" title="Delete"><i style="font-size:15px" class="fa fa-trash"></i></a></td>
            </tr>
              </tbody>
            </table>
          </Widget>
        </b-col>
      </b-row>


    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import gql from "graphql-tag";
  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget },
    data() {
      return {
        spelling: null,
        user_count: 0,
        VUE_APP_DOMAIN_ROOT: process.env.VUE_APP_DOMAIN_ROOT,
        loading: true,
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite'}),
    },
    methods: {
      getSpellingData(){
        axios
                .get(`admin/spelling`)
                .then(
                        response => {
                          this.loading = false;
                          this.spelling = response.data.data;
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );

      },
      deleteWord(word){
        const index = this.spelling.valid_words.indexOf(word);
        this.spelling.valid_words.splice(index, 1);
        axios
                .put(`admin/spelling`, {
                  delete_valid: word
                })
                .then(
                        response => {
                          const index = this.spelling.valid_words.indexOf(word);
                          this.spelling.valid_words.splice(index, 1);
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );
      },
    },
    created() {
      this.$watch("$route",() => { this.currentPage = this.$route.query.page || 1}, {
        immediate: true
      });
    },
    mounted() {
      this.getSpellingData();
    }
  };
</script>

<style src="./CommandCenter.scss" lang="scss" scoped />
<style lang="scss">
  .link-redirect {
    font-size:9pt;
    color:gray;
    padding:4px;
  }
  .link-status-redirect{
    color:red;
    font-size:9pt;
    padding:4px;
  }
  .link-entry{
    max-width:580px;
    overflow:auto;
  }
  .broken-link-preview-image {
    border-radius: 50%;
    max-width: 250px;
    box-shadow: #bdc4e0 0px 0px 20px;
  }
</style>
